<div *ngxPermissionsOnly="permission" class="full-height layout-row">
  <div class="text-ellipsis layout-row"
       *ngFor="let item of viewItems; let last = last"
       [ngClass]="{'item-margin': !last}">

    <app-bringoz-state-link [ngClass]="{ 'text-ellipsis': textEllipsis }"
                            [state]="state"
                            [ngbTooltip]="item.name || item.fullName || item.id"
                            openDelay="300" triggers="hover"
                            [params]="{id: item.id}"
                            [text]="item.name || item.fullName || item.id">
    </app-bringoz-state-link>

    <span *ngIf="!last" class="margin-right-5">,</span>

  </div>

  <div *ngIf="!!extraItems?.length" class="margin-left-5">
    <a class="br-link-1" (click)="onOpenDialog($event)"><span>+{{extraItems.length}}</span></a>
  </div>

</div>
